import { getLocalizedString } from 'owa-datetime-formatters-core';
import { format } from 'owa-localize';
import formatUserTime from './formatUserTime';
import type { OwaDate } from 'owa-datetime';

export default function formatYesterdayAtTime(date: OwaDate): string {
    return format(getLocalizedString('yesterdayTime'), formatUserTime(date));
}
